import { FaInfoCircle } from "react-icons/fa";
import { useQuery } from "@tanstack/react-query";
import { fetchMetrics } from "../../vmeAiApiClient/adapter";

const PhylumMetricsDisplay = ({ phylum, lowering }: { phylum: string; lowering: string }) => {
  const {
    data: metrics,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["rovMetrics", lowering],
    queryFn: () => fetchMetrics(lowering),
    enabled: !!lowering,
  });

  if (isLoading) return <div>Loading metrics...</div>;
  if (error) return <div>Error loading metrics</div>;
  if (!metrics) return null;

  const capitalizedPhylum = phylum.charAt(0).toUpperCase() + phylum.slice(1);

  return (
    <div className="mt-8">
      <h4 className="mb-2 font-bold uppercase tracking-wide text-blue-100">
        {capitalizedPhylum} Detections
      </h4>
      <div className="mb-6 mt-5 pb-4">
        <div>
          <div className="flex items-start">
          <h4 className="mb-2 font-bold text-sm uppercase tracking-wide text-blue-100">
            Density (Length of Transect with {capitalizedPhylum} present)
              </h4>
            <div>
            <FaInfoCircle
              className="cursor-pointer ml-1 text-blue-300 hover:text-blue-400 w-3 h-3"
              onClick={() => {
                document
                  .querySelector("section")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            />
            </div>
            </div>
          <p className="text-lg text-blue-400">
            {parseInt(String(metrics[`${phylum} Density`] * 100))}%
          </p>
        </div>
      </div>

      <div className="mb-6 mt-5 grid grid-cols-3 gap-20 pb-4">
        <div>
          <div className="flex items-center justify-left">
          <div className="flex items-start">
            <h4 className="mb-2 font-bold text-sm uppercase tracking-wide text-blue-100">
              Occurrence (Percentage of Video with {capitalizedPhylum} present)
            </h4>
            <div>
            <FaInfoCircle
              className="cursor-pointer text-blue-300 hover:text-blue-400 w-3 h-3"
              onClick={() => {
                document
                  .querySelector("section")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            />
            </div>
            </div>
          </div>
          <p className="text-lg text-blue-400">
            {parseInt(String(metrics[`${phylum} Occurrence`] * 100))}%
          </p>
        </div>
        <div>
          <h4 className="mb-2 font-bold text-sm uppercase tracking-wide text-blue-100">
            Average {capitalizedPhylum} Depth
          </h4>
          <p className="text-lg text-blue-400">
            {parseInt(metrics[`Average ${phylum} Depth`])}m
          </p>
        </div>
        <div></div>
        <div>
          <h4 className="mb-2 font-bold text-sm uppercase tracking-wide text-blue-100">
            Average Temperature
          </h4>
          <p className="text-lg text-blue-400">
            {parseFloat(metrics[`Average ${phylum} Temperature`]).toFixed(2)} °C
          </p>
        </div>
        <div>
          <h4 className="mb-2 font-bold text-sm uppercase tracking-wide text-blue-100">
            Average Salinity
          </h4>
          <p className="text-lg text-blue-400">
            {parseFloat(metrics[`Average ${phylum} Salinity`]).toFixed(2)} PSU
          </p>
        </div>
        <div>
          <h4 className="mb-2 font-bold text-sm uppercase tracking-wide text-blue-100">
            Average Oxygen
          </h4>
          <p className="text-lg text-blue-400">
            {parseFloat(metrics[`Average ${phylum} Oxygen`]).toFixed(2)} ml/L
          </p>
        </div>
      </div>

      <div className="mt-6">
        <h4 className="mb-2 font-bold text-sm uppercase tracking-wide text-blue-100">
          Plots
        </h4>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className=" rounded-lg p-4">
            <div className="aspect-[4/3] relative">
              <img
                src={`/mockROVData/reports/${lowering}/${phylum}_depth_profile.png`}
                alt={`${capitalizedPhylum} depth profile`}
                className="w-full h-full object-contain"
              />
            </div>
          </div>
          <div className=" rounded-lg p-4">
            <div className="aspect-[4/3] relative">
              <img
                src={`/mockROVData/reports/${lowering}/${phylum}_latlon_profile.png`}
                alt={`${capitalizedPhylum} latitude/longitude profile`}
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhylumMetricsDisplay;
